import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { SnrAuthFieldsFragmentDoc } from '../../graphql/gql-fragments/snr-authorization.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlAuthorizationSelectDialogQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlAuthorizationSelectDialogQuery = { snrAuthorizations: Array<{ id: string, filingYear: string, filingNumber: string, serialNumber: string, registrationDate: string, companyId: string, createdAt: string, updatedAt: string, noBoardStatement: boolean, auths: Array<{ date: string, kind: string, before: string, before_year?: string | null }> }> };


export const AuthorizationSelectDialogDocument = gql`
    query AuthorizationSelectDialog($companyId: ID!) {
  snrAuthorizations(companyId: $companyId) {
    ...SnrAuthFields
    auths {
      date
      kind
      before
      before_year
    }
  }
}
    ${SnrAuthFieldsFragmentDoc}`;

/**
 * __useAuthorizationSelectDialogQuery__
 *
 * To run a query within a React component, call `useAuthorizationSelectDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationSelectDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationSelectDialogQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAuthorizationSelectDialogQuery(baseOptions: Apollo.QueryHookOptions<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables> & ({ variables: GqlAuthorizationSelectDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>(AuthorizationSelectDialogDocument, options);
      }
export function useAuthorizationSelectDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>(AuthorizationSelectDialogDocument, options);
        }
export function useAuthorizationSelectDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>(AuthorizationSelectDialogDocument, options);
        }
export type AuthorizationSelectDialogQueryHookResult = ReturnType<typeof useAuthorizationSelectDialogQuery>;
export type AuthorizationSelectDialogLazyQueryHookResult = ReturnType<typeof useAuthorizationSelectDialogLazyQuery>;
export type AuthorizationSelectDialogSuspenseQueryHookResult = ReturnType<typeof useAuthorizationSelectDialogSuspenseQuery>;
export type AuthorizationSelectDialogQueryResult = Apollo.QueryResult<GqlAuthorizationSelectDialogQuery, GqlAuthorizationSelectDialogQueryVariables>;